import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Info from '@atlaskit/icon/glyph/info';
import { colors } from '@atlaskit/theme';
import SectionMessage from '@atlaskit/section-message';
import { MACTableType } from './TableContent';
import { Dimensions } from '../../../components/visuals';
import config from '../../../appconfig';
import { messages } from '../messages';

const infoIcon = () => <Info label="Info icon" primaryColor={colors.B400} />;

const InfoSectionMessage = styled.td`
  padding-top: ${Dimensions.units(3)}px;
`;

const ppcLink = (
  <a href={config.ppcUrl} target="_blank" rel="noopener noreferrer">
    Partner Purchasing Center
  </a>
);

type Props = {
  tableType: MACTableType;
  isPartner?: boolean;
};

const NoItemsTableContent = ({ tableType, isPartner }: Props) => {
  return (
    <tr>
      {tableType === MACTableType.orders && (
        <InfoSectionMessage colSpan={5}>
          <SectionMessage appearance="information" icon={infoIcon} testId="no-quotes-banner">
            {isPartner ? (
              <FormattedMessage {...messages.partnerOrderNotFound} values={{ ppcLink }} />
            ) : (
              <FormattedMessage {...messages.ordersNoItems} />
            )}
          </SectionMessage>
        </InfoSectionMessage>
      )}
      {tableType === MACTableType.invoices && (
        <InfoSectionMessage colSpan={5}>
          <SectionMessage appearance="information" icon={infoIcon} testId="no-invoices-banner">
            {isPartner ? (
              <FormattedMessage {...messages.partnerOrderNotFound} values={{ ppcLink }} />
            ) : (
              <FormattedMessage {...messages.invoicesNotFound} />
            )}
          </SectionMessage>
        </InfoSectionMessage>
      )}
    </tr>
  );
};

export default NoItemsTableContent;
